<template>
    <!--  <keep-alive exclude="Customer,InformationsContentTab,ContractManagement,ResourceForm,Catalogs">-->
    <app-layout v-if="isLoggedIn"></app-layout>
    <login-layout v-else></login-layout>
    <!--    </keep-alive>-->
</template>

<script type="text/babel">
    import cookies from 'cookiesjs'
    import Echo from 'laravel-echo'
    import AppLayout from './AppLayout'
    import LoginLayout from './LoginLayout'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { FROM_ROUTE_RESTORED } from 'store/mutation-types'
    import userMixin from 'mixins/user'

    export default {
        data () {
            return {
                bodyClassList: null,
                localIP: "109.190.60.72"
            }
        },

        components: {
            AppLayout,
            LoginLayout
        },

        mixins: [
            userMixin
        ],

        created () {
            console.log(`App entered created`)
            // this.checkIPAndEnv()
            // retreive user data now
            this.getUserData()
                .then(() => this.$store.dispatch('fetchAgenciesList'))
                .then(() => this.$store.dispatch('fetchOrganizationsList'))
                .then(() => this.$store.dispatch('fetchSapPromoCodesList'))
        },

        mounted () {
            this.$nextTick()
                .then(() => {
                    const $body = $('body')

                    this.bodyClassList = Array.from($body[0].classList)
                })
                .then(() => {
                    const params = this.$route.params

                    if (params.notify === true) {
                        const style = undefined !== params.notificationStyle ? params.notificationStyle : 'bar'
                        const timeout = undefined !== params.notificationTimeout ? params.notificationTimeout : 5000

                        $('body').pgNotification({
                            style,
                            type: params.notificationType,
                            message: params.notificationMessage,
                            timeout
                        }).show()
                    }
                })
        },

        computed: {
            ...mapState([
                'isLoggedIn',
                'fromRoute',
                'agencies'
            ]),
            ...mapGetters(['userCameFromAnyRoute'])
        },

        activated () {
            console.log(`App entered activated`)
        },

        watch: {
            isLoggedIn (now, before) {
                /**
                 * If user got logged out but logs back in successfully,
                 * App needs to go back to previous route
                 * in order to make children components re-fetch data:
                 *  => last request didn't pass since token wasn't good
                 */
                if (now && !before && this.userCameFromAnyRoute) {
                    console.log('now restoring previous route',
                        this.fromRoute)
                    this.getUserData()
                        .then(() => this.$store.dispatch('fetchAgenciesList'))
                        .then(() => this.$store.dispatch('fetchOrganizationsList'))
                        .then(() => this.$store.dispatch('fetchSapPromoCodesList'))
                    this.$router.push(this.fromRoute)
                    this.$store.commit(FROM_ROUTE_RESTORED)
                }
            }
        },

        methods: {
            ...mapActions('notifications', ['fetchNotificationsOnBroadcast']),

            checkIPAndEnv () {
                const instance = this.axios.create({
                    timeout: 0,
                })
                return instance.get('my_ip').then(response => {
                    const { data: ip } = response.data,
                        APIisProd = process.env.NODE_ENV === 'production' &&
                            /sofradom\.fr/.test(__API_URL__)

                    if (ip === this.localIP && APIisProd) {
                        window.alert('Attention! Vous êtes en local et travaillez sur l\'API en production!')
                    }
                })
            },

            subscribeToUserChannels() {
                let user = this.me
                let userIsAgency = this.isAgency

                if (userIsAgency && user.agencies.length > 0) {
                    _.each(user.agencies, agency => {
                        window.Echo.private(`App.Models.Agency.${agency.id}`)
                            .notification(notification => {
                                this.fetchNotificationsOnBroadcast(notification)
                            })
                    })
                }

                if (user.groups.length > 0) {
                    _.each(user.groups, group => {
                        window.Echo.private(`App.Models.UserGroup.${group.id}`)
                            .notification(notification => {
                                this.fetchNotificationsOnBroadcast(notification)
                            })
                    })
                }
            },

            connectToWebSocket() {
                if (window.Pusher === undefined) {
                    window.Pusher = require('pusher-js');
                }
                    
                if (window.Echo === undefined) {
                    window.Echo = new Echo({
                        broadcaster: 'pusher',
                        key: __PUSHER_KEY__,
                        cluster: __PUSHER_CLUSTER__,
                        encrypted: true,
                        authEndpoint: __API_URL__ + '/broadcasting/auth',
                        auth: {
                        headers: {
                            Authorization: `Bearer ${cookies('token')}`
                        }
                        }
                    })
                } else if (window.Echo.connector.pusher.connection.state != 'connected') {
                    window.Echo.connector.pusher.disconnect()
                    window.Echo = undefined

                    this.connectToWebSocket()
                }

                this.subscribeToUserChannels()
            },

            async getUserData () {
                return await this.$store.dispatch('getLoggedUser')
                                  .then(() => this.$store.dispatch('getUserAgencies'))
                                  .then(() => this.connectToWebSocket())
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/App.vue